<template>
  <v-dialog
    v-model="open"
    max-width="500px"
    @click:outside="closeModal()"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Payment Created</span>
      </v-card-title>

      <v-card-text>
        <v-list density="compact">
          <v-list-item
            :title="'Autopay ID'"
            :subtitle="paymentData.id"
            class="pl-0"
          />
          <v-list-item
            :title="'Method'"
            :subtitle="paymentData.payment_account"
            class="pl-0"
          />
          <v-list-item
            :title="'Date'"
            :subtitle="paymentData.date"
            class="pl-0"
          />
          <v-list-item
            :title="'Type'"
            :subtitle="paymentData.payment_type"
            class="pl-0"
          />
          <v-list-item
            :title="'Amount'"
            :subtitle="'$' + paymentData.amount"
            class="pl-0"
          />
        </v-list>
        <p>Would you like to perform another task or mark this ticket as solved?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          @click="anotherTask()"
        >
          Another Task
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PDSPaymentCreatedModal',

  props: {
    paymentModal: {
      type: Boolean,
      required: false,
      default: false,
    },

    paymentData: {
      type: Object,
      required: true,
    },
  },
  emits: ['closeModal'],

  data() {
    return {
      open: false,
    };
  },

  watch: {
    paymentModal(newValue) {
      this.open = newValue;
    },
  },

  created() {
    this.open = this.paymentModal;
  },

  methods: {
    closeModal() {
      this.$emit('closeModal');
    },

    anotherTask() {
      this.$emit('closeModal');
    },
  },
};
</script>
